import styled from "styled-components";

export const Container = styled.div`
  a,
  button {
    padding-left: 0;
    padding-right: 0;
  }
`;
